const kanban = () => ({
  parentNav: 'kanban',
  routes: ['kanban'],
  menuItems: [],
});

export default kanban;
